















































import { Vue, Component, Prop } from 'vue-property-decorator';

import MonthSlotGeneric from './MonthSlotGeneric.vue';
import CalendarAction from '../CalendarAction.vue';
import IconRemove from '@/components/icons/Remove.vue';
import IconEdit from '@/components/icons/Edit.vue';

import { getMinutesDifference, formatTimeInterval } from '@/utils/date';
import { humanizeToRussian } from '@/utils/date/human';

import { TimeEntry } from '@/components/calendar/types';
import { SlotType, Slot } from '../types';
import { ISOCalendarDate } from '@/utils/date/types';
import { SlotClinic } from '@/api/calendar/backend';

const enum DayStatus {
    Low = 'low',
    Medium = 'medium',
    High = 'high',
}

const STATUS_LIMIT_LOW = 3;
const STATUS_LIMIT_MEDIUM = 5;

@Component({
    components: {
        MonthSlotGeneric,
        CalendarAction,
        IconRemove,
        IconEdit,
    },
})
export default class MonthSlotScheduled extends Vue {
    @Prop({ required: true }) date!: ISOCalendarDate
    @Prop({
        required: true,
        validator: slots => slots.length > 0,
    }) slots!: Slot[]
    @Prop() slotsClinic!: SlotClinic[]
    @Prop({ default: true, type: Boolean }) hasActions!: boolean
    @Prop({ default: null }) clinic!: SlotClinic[] | null

    get isShowActions() {
        return this.$route.name !== 'requests';
    }

    get freeSlots() {
        return this.slots.filter(slot => slot.type === SlotType.Free);
    }

    get freeSlotsCount() {
        return this.freeSlots.length;
    }

    get dayStatus() {
        if (this.freeSlotsCount < STATUS_LIMIT_LOW) {
            return DayStatus.Low;
        }

        if (this.freeSlotsCount < STATUS_LIMIT_MEDIUM) {
            return DayStatus.Medium;
        }

        return DayStatus.High;
    }

    get reservedSlots() {
        return this.slots.filter(slot => slot.type === SlotType.Reserved);
    }

    get workingInterval() {
        const [firstSlot] = this.slots;
        const lastSlot = this.slots[this.slots.length - 1];

        const workingEntry: TimeEntry = {
            start: firstSlot.start,
            end: lastSlot.end,
        }

        return formatTimeInterval(workingEntry);
    }

    get freeTime() {
        const time = this.freeSlots.reduce((time, slot) => {
            const duration = getMinutesDifference(slot);

            return time + duration;
        }, 0);

        return humanizeToRussian(time);
    }

    remove() {
        this.$emit('remove:schedule')
    }

    edit() {
        this.$emit('edit:schedule')
    }

    viewDay() {
        this.$emit('view:day');
    }
}
